module.exports = __webpack_public_path__ + "asset/shunjianTitle_v9RmZM58.png";